export const MAIN_MENU_TRIGGER_KEY = '/';
export const SEARCH_MENU_TRIGGER_KEY = '@';

export const isMenuTriggerKey = (key: string) =>
  [MAIN_MENU_TRIGGER_KEY, SEARCH_MENU_TRIGGER_KEY].includes(key);
